import firebase from 'firebase';
import { uuid } from './uuid';

export const uploadImage = async (
  file: File | undefined,
  directory: string,
  root?: string
) => {
  if (file) {
    const url: { fullPath: string; x700: string } = await firebase
      .storage()
      .ref(`${root || 'courseImages'}/${directory}`)
      .child(`${uuid()}.${file.name.split('.').pop()}`)
      .put(file)
      .then((snapshot) => ({
        fullPath: snapshot.ref.fullPath,
        x700: `${snapshot.ref.fullPath.substr(
          0,
          snapshot.ref.fullPath.lastIndexOf('.')
        )}_700x700.${snapshot.ref.fullPath.split('.').pop()}`,
      }));
    return url;
  }
  return { fullPath: '', x700: '' };
};
